import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import createSelectors from '../utils/createSelectors'

interface State {
  preload: boolean
  isPreloaded: boolean
}
interface Action {
  setPreload: (preload: boolean) => void
  setIsPreloaded: (isPreloaded: boolean) => void
  reset: () => void
}

const initialState: State = {
  preload: true,
  isPreloaded: false
}

const baseStorePreload = create<State & Action>()(
  persist(
    (set) => ({
      preload: true,
      isPreloaded: false,
      setPreload: (preload) => set(() => ({ preload: preload })),
      setIsPreloaded: (isPreloaded) =>
        set(() => ({ isPreloaded: isPreloaded })),
      reset: () => set(initialState)
    }),
    {
      name: 'preload',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        preload: state.preload,
        isPreloaded: state.isPreloaded
      })
    }
  )
)

const useStorePreload = createSelectors(baseStorePreload)

export default useStorePreload
